// extracted by mini-css-extract-plugin
module.exports = {"textarea":"Textarea_textarea__wlYTP","default":"Textarea_default__cqBZ3","fullWidth":"Textarea_fullWidth__fTaFI","noResize":"Textarea_noResize__mIFsQ"};